import { createTheme } from '@mui/material/styles';
import { harmonateTokens as t } from './harmonateTokens';

const harmonateTheme = createTheme({
  palette: {
    primary: {
      main: t.darkBlue,
      light: t.blue,
      dark: t.darkBlue,
      contrastText: t.white,
    },
    secondary: {
      main: t.blue,
      light: t.blue,
      dark: t.darkBlue,
      contrastText: t.white,
    },
    success: {
      main: t.green,
      contrastText: t.white,
    },
    error: {
      main: t.red,
      contrastText: t.white,
    },
    warning: {
      main: t.orange,
      contrastText: t.white,
    },
    info: {
      main: t.blue,
    },
    text: {
      primary: t.text,
      secondary: t.text,
      disabled: t.text,
    },
    background: {
      default: t.listBg,
      paper: t.listBg,
    },
    divider: t.line,
    harmonate: t,
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h5: {
      fontWeight: 700,
      fontSize: '1.25rem',
      lineHeight: 1.334,
    },
    subtitle1: {
      fontWeight: 700,
      fontSize: '0.875rem',
    },
    subtitle2: {
      fontWeight: 700,
      fontSize: '0.75rem',
    },
    body1: {
      fontSize: '0.75rem',
      fontWeight: 400,
    },
    body2: {
      fontSize: '0.75rem',
      fontWeight: 400,
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
      fontSize: '0.875rem',
    },
  },
  shape: {
    borderRadius: 20,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: t.buttonRadius,
          textTransform: 'none',
          fontWeight: 500,
          boxShadow: 'none',
        },
        textPrimary: {
          color: t.text,
        },
        outlinedPrimary: {
          color: t.text,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        colorPrimary: {
          color: t.text,
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: t.text,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: t.text,
          '&.Mui-focused': {
            color: t.text,
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: t.text,
          '&.Mui-error': {
            color: t.red,
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: t.fieldRadius,
            color: t.text,
            '& fieldset': {
              borderColor: t.text,
            },
            '& input::placeholder': {
              color: t.text,
              opacity: 1,
            },
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: t.cardRadius,
          // Accordion extends Paper — keep flush stacks square; group wrapper owns radius
          '&.MuiAccordion-root': {
            borderRadius: 0,
          },
        },
      },
    },
    MuiAccordion: {
      defaultProps: {
        disableGutters: true,
        elevation: 0,
        square: true,
      },
      styleOverrides: {
        root: {
          '&.Mui-expanded': {
            margin: 0,
          },
          '&:before': {
            display: 'none',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: t.buttonRadius,
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: t.blue,
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          display: 'none',
        },
      },
    },
  },
});

export default harmonateTheme;
